import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
export const ExternalAgentsStoreActionTypes = [
    ActionType.FetchExternalAgentsAction,
    ActionType.FetchExternalAgentsFailedAction,
    ActionType.FetchExternalAgentsSucceededAction
];
